import { render, staticRenderFns } from "./garbageExcel.vue?vue&type=template&id=76c1f3c4&scoped=true"
import script from "./garbageExcel.vue?vue&type=script&lang=js"
export * from "./garbageExcel.vue?vue&type=script&lang=js"
import style0 from "./garbageExcel.vue?vue&type=style&index=0&id=76c1f3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c1f3c4",
  null
  
)

export default component.exports